import styles from './styles.module.css'
import LocationDropDown from '../../../../../global/components/location-drop-down/LocationDropDown'
import TextField from '@mui/material/TextField'
import { IScheduleFilter } from '../../../main/ScheduleMain'

export default function ScheduleFilterContainer(props: IScheduleFilter) {
  const { scheduleFilter, setScheduleFilter } = props
  const handleLocationChange = (str: string) => {
    localStorage.setItem('selectedLocationObjectId', str)
    setScheduleFilter({ ...scheduleFilter, locationObjectId: str })
  }

  const handleChange = (e: any) => {
    const { value } = e.target
    localStorage.setItem('selectedDate', value)
    setScheduleFilter({ ...scheduleFilter, date: value })
  }

  return (
    <div className={styles.navContainer}>
      <TextField
        label='Select a Date'
        type='date'
        value={scheduleFilter.date}
        InputLabelProps={{ shrink: true }}
        sx={{ width: 130 }}
        onChange={handleChange}
      />
      <LocationDropDown
        onLocationChange={(val: string) => {
          handleLocationChange(val)
        }}
        defaultValue={scheduleFilter.locationObjectId}
      />
    </div>
  )
}
